export const getErrorsFromFieldState = (fieldState, fieldName) => fieldState?.error ? { [fieldName]: [fieldState.error.message || fieldState.error.type] } : undefined;
